(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/_license_product.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<input type=\"hidden\" name=\"sku_ids\" value=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\">\n<td class=\"comet-data-table__cell\" data-label=\"Remove\">\n    <button class=\"comet-button comet-button--flat comet-button--icon-only comet-button--small remove-product-button\" aria-label=\"Remove Product\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\">\n        <svg class=\"comet-button__icon comet-button__icon--left\" aria-hidden=\"true\" focusable=\"false\">\n            <use xlink:href=\"";
output += runtime.suppressValue((lineno = 4, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#delete"])), env.opts.autoescape);
output += "\"></use>\n        </svg>\n        <span class=\"comet-screenreader-only\">Remove Product</span>\n    </button>\n</td>\n<td class=\"comet-data-table__cell\" data-label=\"Product Name\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
output += "</td>\n<td class=\"comet-data-table__cell\" data-label=\"Product Status\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "status"), env.opts.autoescape);
output += "</td>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/_license_product", function(){});

